import React, { useEffect, useState } from 'react';
import { NavLink, Link, useNavigate } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import Logo from '../assets/images/logo.webp';
import { FaRegUser, FaSignOutAlt, FaCaretDown, FaKey } from "react-icons/fa";
import ErrorImg from '../assets/images/users.png'
const Header = (props) => {
    const [show, setShow] = useState(false);
    const [isSubMenu, setSubMenu] = useState(false);
    const [data, setData] = useState([]);

    const navigate = useNavigate();

    function logOut() {
        setShow(false);
        localStorage.removeItem('useToken');
        localStorage.removeItem('useData');
        navigate("/");
        window.location.reload(true);
    }

    useEffect(() => {
        const storedData = localStorage.getItem("useData");
        if (storedData) {
            setData(JSON.parse(storedData));
        }
    }, [props.data])

    return (
        <>
            <header id="header">
                <div className="header-block">
                    <div className="container">
                        <div className="header-box">
                            <div className="logo-box">
                                <Link to={'/'}>
                                    <img src={Logo} alt='Logo' title='Logo' />
                                </Link>
                            </div>

                            <div className='rightNav'>
                                <div className='userinfo'>
                                    <div className='userimg'>
                                        <img
                                            src={data.image || ErrorImg}
                                            alt="user"
                                            title="user"
                                            onError={(e) => {
                                                e.target.onerror = null; // prevent infinite loop
                                                e.target.src = ErrorImg;
                                            }}
                                        />

                                    </div>
                                    <p>Hello, {data.Name}</p>
                                    <div className='togglemenu'>
                                        <Link onClick={() => setSubMenu(!isSubMenu)}><FaCaretDown /></Link>
                                    </div>
                                </div>
                                {isSubMenu ? (
                                    <div className='submenu'>
                                        <ul>
                                            <li><NavLink to="/profile"><span><FaRegUser /></span> My Profile</NavLink></li>
                                            <li><NavLink to="/change-password"><span><FaKey /></span> Change Password</NavLink></li>
                                            <li><Link onClick={() => setShow(true)}><span><FaSignOutAlt /></span>Logout</Link></li>
                                        </ul>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Logout?</Alert.Heading>
                    <hr />
                    <div className='buttons'>
                        <div>
                            <button onClick={() => logOut()} className='btn btn-green'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-red'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}
        </ >
    )
}

export default Header